import {
  authenticatedFastApiAxiosInstance,
  authenticatedFastApiAxiosInstanceAllowEmptyString,
} from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import { type APIResponse } from "@/lib/types";
import { type MatterLitigationDate } from "../../../types/Matter";

export const createMatterLitigationDateV1 = (
  data: Pick<MatterLitigationDate, "deadlineDate" | "matterId" | "typeId"> &
    Partial<
      Pick<
        MatterLitigationDate,
        | "completedDate"
        | "confirmation"
        | "deadlineTime"
        | "description"
        | "planId"
        | "status"
      >
    >,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<
      APIResponse<MatterLitigationDate>
    >(`${baseFastApiMatterRoute}/litigation-dates`, data)
    .then((res) => res.data);
};

export const updateMatterLitigationDateV1 = (
  data: Pick<MatterLitigationDate, "dateModified" | "id" | "matterId"> &
    Partial<
      Pick<
        MatterLitigationDate,
        | "completedDate"
        | "confirmation"
        | "deadlineDate"
        | "deadlineTime"
        | "description"
        | "planId"
        | "status"
        | "typeId"
      >
    >,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<
      APIResponse<MatterLitigationDate>
    >(`${baseFastApiMatterRoute}/litigation-dates`, data)
    .then((res) => res.data);
};

export const deleteMatterLitigationDateV1 = (
  data: Pick<MatterLitigationDate, "id" | "matterId">,
) => {
  const { id } = data;

  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterLitigationDate>
    >(`${baseFastApiMatterRoute}/litigation-dates/${id}`)
    .then((res) => res.data);
};
